<template>
  <div class="d-flex align-center flex-column">
    <v-card>
      <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="true"
        :preview-modal="false"
        :filename="pdfFileName"
        :paginate-elements-by-height="60"
        :pdf-quality="2"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="400px"
        :manual-pagination="true"
        :margin="0.0"
        :htmlToPdfOptions="htmlToPdfOptions"
        ref="html2Pdf"
      >
        <section slot="pdf-content" style="margin: 4px">
          <div class="aptitud-medica formato-medico-container">
            <v-card
              outlined
              class="pa-4 card-shadow"
              style="max-width: 400px; margin: auto; padding: 4px"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 8px;
                "
              >
                <!-- Logo -->
                <div style="width: 28%; text-align: left">
                  <img
                    src="/static/logo_sp.png"
                    alt="Logo"
                    style="width: 80px; height: auto"
                  />
                </div>
                <!-- Título -->
                <div style="width: 28%; text-align: center; font-size: 13px">
                  <div class="title-doc">APTITUD MÉDICA</div>
                </div>
                <!-- Códigos -->
                <div style="width: 44%; text-align: right; font-size: 10px">
                  <div><strong>CÓDIGO:</strong> SIG-ST-SO-FR-027</div>
                  <div><strong>VERSIÓN:</strong> 02</div>
                  <div><strong>Fecha verificación:</strong> 28/09/2020</div>
                  <div><strong>Última revisión:</strong> 14/07/2025</div>
                  <div><strong>Páginas:</strong> 1 de 1</div>
                </div>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="label">Nombre y Apellidos:</div>
              <div></div>
              <div class="d-flex flex-column mt-4">
                <div class="checkbox-group mt-4">
                  <div class="checkbox-row">
                    <label class="checkbox-label">
                      APTO
                      <input
                        type="checkbox"
                        :checked="item.MevStatus === 1"
                        disabled
                      />
                    </label>
                    <label class="checkbox-label">
                      APTO CON RESTRICCIÓN
                      <input
                        type="checkbox"
                        :checked="item.MevStatus === 2"
                        disabled
                      />
                    </label>
                  </div>
                  <div class="checkbox-row">
                    <label class="checkbox-label">
                      OBSERVADO
                      <input
                        type="checkbox"
                        :checked="item.MevStatus === 4"
                        disabled
                      />
                    </label>
                    <label class="checkbox-label">
                      NO APTO
                      <input
                        type="checkbox"
                        :checked="item.MevStatus === 3"
                        disabled
                      />
                    </label>
                  </div>
                </div>
                <br>
                <b>
                  Indicaciones:
                </b>
                {{ item.MevIndications ? item.MevIndications : 'No hay indicaciones.' }}
                <!-- <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div> -->
              </div>
              <div
                style="
                  display: flex;
                  align-items: flex-end;
                  justify-content: center;
                  margin-top: 50px;
                "
              ></div>
              <img
                v-if="signatureImage"
                :src="signatureImage"
                alt="Firma del Médico Ocupacional"
                style="width: 160px; height: auto; display: block; margin: auto"
              />
              <div class="line mt-1"></div>
              <!-- <div class="text-center small-text mt-1">
                FIRMA Y SELLO DEL MÉDICO OCUPACIONAL
              </div> -->
              <div class="text-center small-text font-weight-bold"  style="text-align: center;">
                {{ item.DocName }}
              </div>
            </v-card>
          </div>
        </section>
      </vue-html2pdf>
    </v-card>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import GenUploadFiles from "@/services/General/GenUploadFiles";

export default {
  name: "AptitudeCardPdf",
  components: {
    VueHtml2pdf,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      signatureImage: null,
      htmlToPdfOptions: {
        margin: [0.1, 0.2, 0.1, 0.2],
        filename: `aptitud_medica.pdf`,
        jsPDF: {
          orientation: "portrait",
        },
        html2canvas: {
          letterRendering: true,
        },
      },
    };
  },
  computed: {
    statusColor() {
      switch (this.item && this.item.MevStatus) {
        case 1:
          return "#2e7d32"; // APTO
        case 2:
          return "#ff8f00"; // APTO CON RESTRICCIÓN
        case 3:
          return "#c62828"; // NO APTO
        case 4:
          return "#1565c0"; // OBSERVADO
        default:
          return "#9e9e9e";
      }
    },
    pdfFileName() {
      const doc = this.item?.MevDocumentNumber || "Aptitud";
      const dni = this.item?.PrsDocumentNumber || "Paciente";
      return `AptitudMedica_${doc}_${dni}.pdf`;
    },
  },
  mounted() {
    this.loadSignature();
  },
  watch: {
    item: {
      handler() {
        this.loadSignature();
      },
      deep: true,
    },
  },
  methods: {
    loadSignature() {
      if (this.item && this.item.DocName) {
        GenUploadFiles.getFile("routeSignatures", this.item.DocName, true)
          .then((base64) => {
            this.signatureImage = base64;
          })
          .catch((error) => {
            console.error("Error al obtener imagen de firma:", error);
            this.signatureImage = null;
          });
      } else {
        this.signatureImage = null;
      }
    },
    printPdf() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style scoped>
.formato-medico-container {
  background-color: #fff;
  padding: 8px;
}

.aptitud-medica {
  max-width: 400px;
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
}

.status-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.card-shadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.2s;
}

.card-shadow:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}

.title-doc {
  font-weight: bold;
  font-size: 10px;
  text-align: center;
  margin-top: 8px;
}

.label {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 2px;
}

.line {
  border-bottom: 1px solid #000;
  min-height: 18px;
  font-size: 14px;
  padding-left: 4px;
}

.small-text {
  font-size: 10px;
  line-height: 1.2;
}

.text-wrap {
  white-space: pre-wrap;
}
/* Solo para el PDF */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.checkbox-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
}
.checkbox-label {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  gap: 4px;
  font-weight: normal;
  min-width: 160px;
}
.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

</style>